import { render, staticRenderFns } from "./Create-Customer.vue?vue&type=template&id=1014388e&scoped=true"
import script from "./Create-Customer.vue?vue&type=script&lang=js"
export * from "./Create-Customer.vue?vue&type=script&lang=js"
import style0 from "./Create-Customer.vue?vue&type=style&index=0&id=1014388e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1014388e",
  null
  
)

export default component.exports